$(document).ready(function () {
  let p = $("body").attr("p");
  let posType = $("body").attr("pos_type");
  if (p == "events" && posType == "classic") {
    const $container = $("#classic-category-product-container");
    const $tabs = $(".classic-category-nav-link");

    let touchStartX = 0;
    let touchEndX = 0;
    const swipeThreshold = 60;

    function scrollToTab($tab) {
      setTimeout(() => {
        $tab[0].scrollIntoView({
          behavior: "smooth",
          inline: "center",
          block: "nearest",
        });
      }, 80);
    }
    $container.on("touchstart", function (e) {
      touchStartX = e.originalEvent.touches[0].clientX;
    });

    $container.on("touchend", function (e) {
      touchEndX = e.originalEvent.changedTouches[0].clientX;

      const diffX = touchStartX - touchEndX;

      // Small movement → ignore (not a real swipe)
      if (Math.abs(diffX) < swipeThreshold) return;

      // Find current active tab
      const $activeTab = $tabs.filter(".active");
      if (!$activeTab.length) return;

      const currentIndex = $tabs.index($activeTab);

      if (diffX > 0) {
        if (currentIndex < $tabs.length - 1) {
          const $nextTab = $tabs.eq(currentIndex + 1);
          $nextTab.trigger("click");
          $nextTab.addClass("active");
          setTimeout(() => {
            $nextTab[0].scrollIntoView({
              behavior: "smooth",
              inline: "center",
              block: "nearest",
            });
          }, 60);
        }
      } else {
        if (currentIndex > 0) {
          const $prevTab = $tabs.eq(currentIndex - 1);
          $prevTab.trigger("click");
          $prevTab.addClass("active");
          setTimeout(() => {
            $prevTab[0].scrollIntoView({
              behavior: "smooth",
              inline: "center",
              block: "nearest",
            });
          }, 60);
        }
      }
    });
  }
});
